import { Text } from "src/common/Text";
import { cn } from "@/libs/utils";

export function Breadcrumb({ labels }: { labels: string[] }) {
  return (
    <div>
      <div className="flex w-full items-center justify-start gap-x-0.5">
        {labels.map((label, index) => {
          const last = labels.length - 1 === index;
          return (
            <div key={index} className="flex items-center gap-x-0.5">
              <Text
                text={label}
                className={cn("whitespace-nowrap text-xs font-400", {
                  "font-600": last,
                })}
              />
              {!last && (
                <span className="px-2 text-sm text-coolgray-30"> / </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
